var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-1 inner"},[_c('div',{staticClass:"divider-1-subtitle"},[_vm._v(_vm._s(_vm.item.subtitle))]),_c('div',{staticClass:"divider-1-title"},[_vm._v(_vm._s(_vm.item.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }